import pallet from 'constants/colors';

export default {
  container: {
    maxWidth: 380,
    width: '100%',
    minWidth: 300,
    borderRadius: 8,
    height: 460,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: 24,
    paddingBottom: 24,
  },
  action: {
    minHeight: 40,
    maxHeight: 40,
    justifyContent: 'center',
    marginLeft: 0,
    marginRight: 0,
    marginTop: 10,
  },
  actionButton: {
    fontSize: 14,
    maxWidth: 'none',
    paddingLeft: 0,
    whiteSpace: 'nowrap',
    color: pallet.titleColor,
    float: 'right',
  },
  divider: {
  },
  times: {
    marginTop: 'auto',
    marginBottom: 18,
    display: 'flex',
    justifyContent: 'space-between',
    float: 'right',
  },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 12,
  },
  description: {
    color: pallet.subtitleColor,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  amount: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 6,
    fontSize: 14,
    fontWeight: 600,
  },
  fileInput: {
    marginTop: 6,
    minHeight: 28,
  },
  validDate: {
    fontSize: 14,
    fontWeight: 600,
  },
  amountInput: {
  },
};



// WEBPACK FOOTER //
// ./src/styles/KBenefit.js